"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productContext = exports.TestProductProvider = exports.ProductProvider = void 0;
var _react = require("react");
var _useGetGroupedProduct = require("../api/useGetGroupedProduct");
var _jsxRuntime = require("react/jsx-runtime");
const currentShadeDefaultValue = {
  isDiscontinued: false,
  canBeReserved: false,
  canBeSold: false,
  canBeSubscribed: false,
  color: {
    name: null
  },
  dealLabel: undefined,
  imageUrl: null,
  bonusPoints: 0,
  nextAvailableDateText: null,
  pdpUrl: null,
  ppaLabel: undefined,
  price: {
    basicCashback: null,
    current: null,
    combinedCashback: null,
    old: null,
    previousMinOfferPrice: null,
    priceAfterImmediateDiscount: null
  },
  productCode: '',
  size: null,
  subscription: {
    available: false,
    deliveryFrequencyOptions: [],
    recommendedFrequency: 0
  },
  subscriptionBenefitBanner: null
};
const productContext = exports.productContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = productContext;
const TestProductProvider = exports.TestProductProvider = Provider;
const ProductProvider = ({
  children,
  value: currentProduct
}) => {
  const {
    code,
    shades
  } = currentProduct;
  const [currentProductCode, setCurrentProductCode] = (0, _react.useState)(code);
  const [currentShadeCode, setCurrentShadeCode] = (0, _react.useState)(currentProductCode);
  const currentShade = (0, _react.useMemo)(() => shades.find(product => product.productCode === currentShadeCode) ?? shades[0], [currentShadeCode, shades]);
  const isMultiShadeEnabled = shades.length > 1;
  const {
    loading,
    onGroupedProductCodeClick
  } = (0, _useGetGroupedProduct.useGetGroupedProduct)(code);
  const contextValue = (0, _react.useMemo)(() => ({
    currentProduct,
    currentProductCode,
    currentShade: currentShade ?? currentShadeDefaultValue,
    isMultiShadeEnabled,
    loading,
    onGroupedProductCodeClick,
    setCurrentProductCode,
    setCurrentShadeCode
  }), [currentProduct, currentProductCode, currentShade, isMultiShadeEnabled, loading, onGroupedProductCodeClick]);
  if (!currentShade) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: contextValue,
    children: children
  });
};
exports.ProductProvider = ProductProvider;
